import React from 'react';
import PropTypes from 'prop-types';
import { EmployeeIcon } from '../Icons';

const AssociateLogo = ({ classes }) => {
  return <EmployeeIcon className={classes.associate} />;
};

AssociateLogo.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
};

AssociateLogo.defaultProps = {
  classes: {},
};

export default AssociateLogo;
